export const TITLE = 'Lark';
export const COLOR_PRIMARY = '#fff';
